import actionCreatorFactory, {
  ActionCreator,
  ActionCreatorFactory
} from "typescript-fsa"
import type { KeysOfType, CollectionTypes } from ".."

// Basic handler function for creating state handlers
export function handler<Model, T>(key: KeysOfType<Model, T>) {
  return (state: Model, value: any): Model => ({ ...state, [key]: value })
}

// Action creator for type-based contexts
export function actionCreatorTypeGuard<Model, X>(
  key: KeysOfType<Model, X>,
  type: string
): [ActionCreator<X>, (state: Model, value: X) => Model] {
  const creator = actionCreatorFactory(type)<X>(key as string)
  return [creator, handler<Model, X>(key)]
}

// Action creator for collection-based contexts
export function actionCreatorGuard<Model, X>(
  key: KeysOfType<Model, X>,
  collection: KeysOfType<CollectionTypes, Model>
): [ActionCreator<X>, (state: Model, value: X) => Model] {
  const creator = actionCreatorFactory(collection)<X>(key as string)
  return [creator, handler<Model, X>(key)]
}

export type reducerActions<Model> = Record<
  keyof Omit<Model, "kind">,
  [ActionCreator<any>, (state: Model, value: any) => Model]
>
